<div
  *ngIf="(isFeatureFlagsLoaded$ | async) && { enableMagicLinkExperience: enableMagicLinkExperience$ | async } as cfg"
  class="login-container"
>
  <app-login-banner *ngIf="configService.loginBannerEnabled && !cfg.enableMagicLinkExperience; else placeholder"></app-login-banner>

  <ng-template #placeholder>
    <div></div>
  </ng-template>

  <div class="grid-cont login-container__card" [ngClass]="{ 'my-auto': !configService.loginBannerEnabled }">
    <div class="login login-container__card__content">
      <aiwyn-logo height="60" [extraClasses]="'my-6 login__logo'"></aiwyn-logo>

      <div *ngIf="{ value: loginFormType$ | async } as loginFormType" class="block login__cont p-6">
        <ng-container *ngIf="cfg.enableMagicLinkExperience; else oldLoginExperience">
          <h2>Sign in to {{ customerName$ | async }}</h2>
        </ng-container>

        <ng-template #oldLoginExperience>
          <h2 *ngIf="loginFormType.value === LoginFormTypes.ORIGINAL_USERNAME_PASSWORD; else signInToCustomerNameTemplate">
            Log in to Your Account
          </h2>
          <ng-template #signInToCustomerNameTemplate>
            <h2>Sign in to {{ customerName$ | async }}</h2>
          </ng-template>
        </ng-template>

        <form name="loginForm" [formGroup]="loginForm" novalidate class="mt-6">
          <div class="form-control">
            <label class="{{ cfg.enableMagicLinkExperience ? 'body-400 color-gray-300' : 'body-300 color-gray-100' }} ta--left">Email address</label>

            <div class="input-div mt-2">
              <input
                type="email"
                name="email"
                formControlName="email"
                autocomplete="username"
                [placeholder]="cfg.enableMagicLinkExperience ? '' : 'name@email.com'"
                class="form-input"
                [ngClass]="{ 'form-input--invalid': (loginForm.controls.email.errors && canShowValidationErrors(loginForm.controls.email)) || authenticationUserError() }"
                data-cy="username"
              >

              <div class="form-control__post-icon">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  stroke="currentColor"
                  stroke-width="2"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
              </div>
            </div>

            <mat-error *ngIf="(loginForm.controls.email.errors && canShowValidationErrors(loginForm.controls.email)) || !this.lockedEmailIsValid || authenticationUserError()">
              A valid email is required
            </mat-error>
          </div>

          <ng-container *ngIf="shouldShowPasswordInput$ | async">
            <div class="mt-6 form-control">
              <label class="{{ cfg.enableMagicLinkExperience ? 'body-400 color-gray-300' : 'body-300 color-gray-100' }} ta--left">Password</label>

              <div class="input-div mt-2">
                <input
                  type="password"
                  name="password"
                  [placeholder]="cfg.enableMagicLinkExperience ? '' : 'Password *'"
                  class="form-input"
                  [ngClass]="{ 'form-input--invalid': loginForm.controls.password.errors && canShowValidationErrors(loginForm.controls.password) }"
                  formControlName="password"
                  data-cy="password"
                >
                <div class="form-control__post-icon">
                  <svg
                    viewBox="0 0 24 24"
                    width="16"
                    height="16"
                    stroke="currentColor"
                    stroke-width="2"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </svg>
                </div>
              </div>

              @if (loginForm.controls.password.errors && canShowValidationErrors(loginForm.controls.password)) {
                <mat-error>Password is required</mat-error>
              } @else if (authenticationError()) {
                <mat-error class="d-block mt-4">{{ authenticationError() }}</mat-error>
              }
            </div>

            <button
              id="loginButton"
              andButton
              color="primary"
              size="large"
              class="w-100 mt-6"
              [isLoading]="isSignInProcessing$ | async"
              (click)="signInWithUsernameAndPassword()"
              data-cy="user-login"
            >
              {{ cfg.enableMagicLinkExperience ? 'Sign in' : loginButtonText }}
            </button>
          </ng-container>

          <!-- TODO passwordless: make andButton with loading state -->
          <button
            *ngIf="loginFormType.value === LoginFormTypes.EMAIL_LINK"
            id="emailLinkLoginButton"
            andButton
            color="primary"
            size="large"
            class="w-100 mt-6"
            [isLoading]="isSignInProcessing$ | async"
            (click)="signInWithEmailLink()"
            data-cy="email-link-login"
          >
            {{
              cfg.enableMagicLinkExperience
                ? "Request a magic sign-in link"
                : "Sign in with email"
            }}
          </button>

          <ng-container *ngIf="cfg.enableMagicLinkExperience && loginFormType.value === LoginFormTypes.EMAIL_LINK">
            <p class="mt-4 body-300 color-gray-100">We’ll email you a link. Just click it to sign in.</p>
            <p class="body-300 color-gray-100">No password needed!</p>

            <div class="hr-spacer login__hr"><span>OR</span></div>

            <button andButton class="mt-6 w-100" color="secondary" size="large" (click)="enableSignInWithPassword()">
              Sign in with a password
            </button>
          </ng-container>

          <p
            *ngIf="loginFormType.value === LoginFormTypes.EMAIL_LINK && !cfg.enableMagicLinkExperience"
            class="bg-color-gray-1000 rounded-all-1 p-3 mt-6 body-300 ta--left"
          >
            We'll email you a magic link for a password-free sign in. Or you can
            <button andButton color="hyperlink" class="d-inline p-0 fw-light" (click)="enableSignInWithPassword()">
              sign in with a password instead
            </button>.
          </p>

          <p
            *ngIf="loginFormType.value === LoginFormTypes.USERNAME_PASSWORD && !cfg.enableMagicLinkExperience"
            class="body-300 ta--left mt-4"
          >
            Forgot your password?
            <button andButton color="hyperlink" class="d-inline fw-light p-0" (click)="getHelpSigningIn()">
              Get help signing in
            </button>.
          </p>

          <div *ngIf="loginFormType.value === LoginFormTypes.ORIGINAL_USERNAME_PASSWORD && !cfg.enableMagicLinkExperience">
            <button
              type="button"
              class="mt--100 text-button"
              data-cy="change-password"
              *ngIf="resetPasswordEnabled"
              (click)="changePassword()"
            >
              {{ forgotPasswordText }}
            </button>

            <div class="mt--150 login__hr"><span>OR</span></div>

            <button
              andButton
              color="secondary"
              size="large"
              id="createAccountButton"
              class="mt--200 w-100"
              data-cy="create-account"
              (click)="onCreateAccountRequested.emit()"
            >
              {{ createAccountButtonText }}
            </button>
          </div>

          <ng-container *ngIf="loginFormType.value === LoginFormTypes.USERNAME_PASSWORD && cfg.enableMagicLinkExperience">
            <div class="mt--150 login__hr"><span>OR</span></div>

            <p class="body-300 mt-4 color-gray-100">
              Forgot your password or not sure if you have one?
            </p>

            <button
              *ngIf="resetPasswordEnabled"
              andButton
              color="secondary"
              size="large"
              class="w-100 mt-6"
              type="button"
              (click)="changePassword()"
            >
              Get help signing in
            </button>
          </ng-container>

        </form>
      </div>

      <ng-container *ngIf="showGuestLogin()">
        <p class="body-400 mt-4 color-gray-100 text-center mb-1">
          Want to pay a bill without signing in?
        </p>
        <div class="d-flex justify-content-center">
          <button
            andButton
            color="hyperlink"
            class="p-0 fw-light"
            (click)="getClientKeyForAnonymousUser()"
            data-cy="guest-login"
          >
            {{ "Go to guest checkout" }}
          </button>
        </div>
      </ng-container>
    </div>
    <app-full-client-portal-footer class="mt-6"></app-full-client-portal-footer>
  </div>

  <div class="pb-6"></div>
</div>
